export enum FeatureFlagEnum {
  NEW_MEASUREMENT_FIELD = 'new-measurement-field',
  CALENDAR = 'calendar',
  RESOURCES = 'resources',
  PRODUCTIONS = 'productions',
  SHORTLISTS = 'shortlists',
  CALLOUTS = 'callouts',
  CALLSHEETS = 'callsheets',
  BOOKINGS = 'bookings',
  BUDGETING = 'budgeting',
  FINANCIALS = 'financials',
  REPORTING = 'reporting',
  RECONCILIATIONS = 'reconciliations',
  NIKECUSTOM_FRONT_DESK = 'custom-nikefrontdesk',
  NIKECUSTOM_ARRIVAL_BOARD = 'custom-nikearrivalboard',
  NIKECUSTOM_QR_CODE = 'custom-nikeqrcode',
  BOOKING_CONFIRMATION = 'booking_confirmation',
  TASKS = 'tasks',
  CUSTOM_SPLASHLIGHT = 'custom-splashlight',
  CUSTOM_SHOTFLOW = 'custom-shotflow',
  SEARCH_FROM_SOURCE = 'search-from-source',
  NON_N_PLUS_1_PRODUCTIONS = 'non-n-plus-1-productions',
  NON_N_PLUS_1_CONTACTS = 'non-n-plus-1-contacts',
  NON_N_PLUS_1_CALLSHEETS = 'non-n-plus-1-callsheets',
  SHORTLIST_V5 = 'shortlist-v5'
}
